import { store } from '../../../../appStore';
import * as actionTypes from '../../../../models/actionTypes';
import { getEmailFromCustomerContacts } from '../../../../utilities';
import { FreelanceRequest, UpdateContactsResponseModel } from '../../models/requestModels';
import { phoneFieldPlaceHolderSelector } from '../selectors/requestSelector';

export const setDirtyRequest = (dirtyRequest: Partial<FreelanceRequest>) => {
  let request = dirtyRequest;
  // setting request for beginning of request editing
  if (dirtyRequest) {
    const state = store.getState();
    request = { ...dirtyRequest };
    request.UserEmail = getEmailFromCustomerContacts(request);
    const placeHolder = phoneFieldPlaceHolderSelector(state);
    if (placeHolder && placeHolder.region) {
      request.UserPhoneDialingCodeIndex = request.UserPhoneDialingCodeIndex === null ? placeHolder.index.toString() : request.UserPhoneDialingCodeIndex;
      request.TwoDigitCountryCode = request.TwoDigitCountryCode || placeHolder.region.TwoDigitCountryCode;
    }
  }
  return {
    type: actionTypes.SET_DIRTY_REQUEST,
    request,
  };
};

export const updateDirtyRequest = (dirtyRequest: Partial<FreelanceRequest>) => {
  return {
    type: actionTypes.UPDATE_DIRTY_REQUEST,
    request: dirtyRequest,
  };
};

export const updateAttachments = () => {
  return {
    type: actionTypes.UPDATE_ATTACHMENTS,
  };
};

export const updateAttachmentsSuccess = (dirtyRequest: FreelanceRequest) => {
  return {
    type: actionTypes.UPDATE_ATTACHMENTS_SUCCESS,
    dirtyRequest,
  };
};

export const updateAttachmentsError = () => {
  return {
    type: actionTypes.UPDATE_ATTACHMENTS_ERROR,
  };
};

export const updateNote = (note: string) => {
  return {
    type: actionTypes.UPDATE_NOTE,
    note,
  };
};

export const addNote = () => {
  return {
    type: actionTypes.ADD_NOTE,
  };
};

export const addNoteSuccess = (dirtyRequest: FreelanceRequest) => {
  return {
    type: actionTypes.ADD_NOTE_SUCCESS,
    dirtyRequest,
  };
};

export const addNoteError = () => {
  return {
    type: actionTypes.ADD_NOTE_ERROR,
  };
};

export const updateIsPhoneNumberValidForEdit = (isPhoneNumberValid: boolean) => {
  return {
    type: actionTypes.UPDATE_IS_PHONENUMBER_VALID_FOR_EDIT,
    isPhoneNumberValid,
  };
};

export const updateIsEmailValidForEdit = (isEmailValid: boolean) => {
  return {
    type: actionTypes.UPDATE_IS_EMAIL_VALID_FOR_EDIT,
    isEmailValid,
  };
};

export const updateContacts = () => {
  return {
    type: actionTypes.UPDATE_CONTACTS,
  };
};

export const updateContactsSuccess = (dirtyRequest: FreelanceRequest, response: UpdateContactsResponseModel) => {
  return {
    type: actionTypes.UPDATE_CONTACTS_SUCCESS,
    dirtyRequest,
    response,
  };
};

export const updateContactsError = () => {
  return {
    type: actionTypes.UPDATE_CONTACTS_ERROR,
  };
};

export const resetRequestDetailsEditError = () => {
  return {
    type: actionTypes.RESET_REQUEST_DETAILS_EDIT_ERROR,
  };
};

export const updateBusinessImpactConfirmedForEdit = (businessImpactConfirmed: boolean) => {
  return {
    type: actionTypes.UPDATE_BUSINESS_IMPACT_CONFIRMED_FOR_EDIT,
    businessImpactConfirmed,
  };
};

export const updateCustomerAvailabilityConfirmedForEdit = (customerAvailabilityConfirmed: boolean) => {
  return {
    type: actionTypes.UPDATE_CUSTOMER_AVAILABILITY_CONFIRMED_FOR_EDIT,
    customerAvailabilityConfirmed,
  };
};
